import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import StatusDropdown from "./status-dropdown.vue";
import { mapActions } from "vuex";
import { UPDATE_FILOGIX_SUBMISSION, LOAD_FILOGIX_SUBMISSIONS, UPDATE_FILOGIX_SUBMISSION_STATUS } from "../../../../../store/application-actions";
import InlinePrompt from "@Shared/components/general/inline-prompt.vue";
import SyncError from "../expert-sync-application/sync-error.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "DealRow",
  components: {
    StatusDropdown,
    SimpleButton,
    InlinePrompt,
    SyncError
  },
  props: {
    submission: {
      type: Object,
      required: true
    },
    lenders: {
      type: Array,
      default: () => []
    },
    clientUsername: {
      type: String,
      required: true
    },
    applicationId: {
      type: Number,
      required: true
    },
    agentUsername: {
      type: String,
      required: true
    },
    disableSync: {
      type: Boolean,
      default: false
    },
    hasIncident: {
      type: Boolean,
      default: false
    },
    syncProgress: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      savingDeal: false,
      savingStatus: false
    };
  },
  computed: {
    allowSync() {
      return this.filogixId && !this.savingDeal && !this.disableSync;
    },
    filogixSubmissionId() {
      return this.submission.filogixSubmissionId;
    },
    filogixId() {
      return this.submission.filogixId;
    },
    createdAt() {
      return this.submission.createdAt;
    },
    status() {
      return this.submission.status;
    },
    statusCancelled() {
      return this.submission.status == "cancelled";
    },
    statusFailed() {
      return this.submission.status == "failed";
    },
    filogixSyncStatus() {
      return this.submission.filogixSyncStatus;
    },
    showFilogixSyncStatusTooltip() {
      var _context;
      return _includesInstanceProperty(_context = ["success", "failed"]).call(_context, this.filogixSyncStatus);
    },
    filogixSyncStatusTooltipText() {
      const textMap = {
        success: this.$t("filogix.successSync"),
        failed: "There was a recent failed sync with this deal."
      };
      return textMap[this.filogixSyncStatus];
    },
    filogixSyncStatusTooltipIcon() {
      const textMap = {
        success: "check",
        failed: "exclamation"
      };
      return textMap[this.filogixSyncStatus];
    },
    filogixSyncStatusTooltipColor() {
      const textMap = {
        success: "text-success",
        failed: "text-danger"
      };
      return textMap[this.filogixSyncStatus];
    },
    isPartialSync() {
      var _this$filogixId;
      return this.status == "failed" && !!((_this$filogixId = this.filogixId) != null && _this$filogixId.length);
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions("ApplicationStore", [UPDATE_FILOGIX_SUBMISSION, LOAD_FILOGIX_SUBMISSIONS, UPDATE_FILOGIX_SUBMISSION_STATUS])), {}, {
    async handleDealSave(data) {
      try {
        this.savingDeal = true;
        await this.UPDATE_FILOGIX_SUBMISSION({
          applicationId: this.applicationId,
          clientUsername: this.clientUsername,
          filogixSubmissionId: this.filogixSubmissionId,
          details: data
        });
        await this.LOAD_FILOGIX_SUBMISSIONS({
          applicationId: this.applicationId,
          clientUsername: this.clientUsername
        });
      } finally {
        this.savingDeal = false;
      }
    },
    async handleStatusChange(status) {
      this.savingStatus = true;
      await this.UPDATE_FILOGIX_SUBMISSION_STATUS({
        applicationId: this.applicationId,
        clientUsername: this.clientUsername,
        filogixSubmissionId: this.filogixSubmissionId,
        status
      });
      this.savingStatus = false;
    },
    handleSyncClick() {
      this.$emit("sync", this.filogixSubmissionId);
    }
  })
});